export default __webpack_public_path__ + "static/media/jipfile.fb188e1a.png";